import { Box, HStack } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Link } from '@televet/kibble-ui/build/components/Link';
import { Spinner } from '@televet/kibble-ui/build/components/Spinner';
import React from 'react';

interface IRefreshLinkProps {
  onClick: () => void;
  isLoading: boolean;
  title?: string;
}

const RefreshLink = ({ onClick, isLoading, title }: IRefreshLinkProps): JSX.Element => {
  return (
    <HStack>
      <Box>
        {isLoading ? (
          <Box mr={1}>
            <Spinner size="xs" />
          </Box>
        ) : (
          <Box mt={1.5} mr="0 !important">
            <Icon name="doubleArrowCircle" size="sm" variant="interactive" />
          </Box>
        )}
      </Box>
      <Link color={isLoading ? 'text.inactive' : 'text.link'} onClick={onClick} fontSize="sm" fontWeight="bold">
        {title || 'Refresh'}
      </Link>
    </HStack>
  );
};

export default RefreshLink;
